import { LoadingOutlined } from '@ant-design/icons'
import { Button, Input, Result, Form } from 'antd'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../../../../redux/context/company/selectors'
import { useBackend } from '../../../../../../services/backend'
import { SeveraApiSecret } from '../../types'
import { notificationAction } from '../../../../../../redux/middleware/actions'
import { AppDispatch } from '../../../../../../redux/store'
import DataUpdate from '../../dataUpdate'

const SeveraApi: React.FC = () => {
  const { t } = useTranslation()
  const companyId = useSelector(contextCompanyIdSelector)
  const getCredentials = useBackend(`/severa/authentication/{companyId}`, process.env.REACT_APP_INTEGRATION_URL)
  const setCredentials = useBackend(`/severa/authentication/{companyId}`, process.env.REACT_APP_INTEGRATION_URL)

  const dispatch: AppDispatch = useDispatch()

  const [clientSecret, setSecret] = useState<string>()
  const [clientId, setClientId] = useState<string>()
  const [authorized, setAuthorized] = useState(false)

  const getCredentialsHandler = () => {
    getCredentials
      .get({
        urlParams: { companyId }
      })
      .then((credentials: SeveraApiSecret) => {
        setSecret(credentials.clientSecret)
        setClientId(credentials.clientId)
        credentials.clientSecret ? setAuthorized(true) : setAuthorized(false)
      })
      .catch(() => {
        setSecret('')
        setClientId('')
        setAuthorized(false)
      })
  }

  useEffect(getCredentialsHandler, [companyId])

  const submit = () => {
    setCredentials
      .put({
        urlParams: { companyId },
        body: {
          data: {
            clientSecret,
            clientId
          }
        }
      })
      .then((credentials: SeveraApiSecret) => {
        setSecret(credentials.clientSecret)
        setClientId(credentials.clientId)
        setAuthorized(true)
        dispatch(
          notificationAction({
            type: 'success',
            message: 'AUTHENTICATION_SUCCESS'
          })
        )
      })
      .catch(() => {
        setAuthorized(false)
        dispatch(
          notificationAction({
            type: 'error',
            message: 'AUTHENTICATION_ERROR',
            description: 'USERNAME_PASSWORD_MISMATCH'
          })
        )
      })
  }

  const emptyCredentials = () => {
    setSecret('')
    setClientId('')
    setAuthorized(false)
  }

  if (authorized) {
    return (
      <>
        <Result
          status="success"
          title={t('integrationsPage:authenticated')}
          extra={
            <>
              <Button onClick={emptyCredentials} type="primary">
                {t('integrationsPage:authenticate')}
              </Button>
              <DataUpdate page="severa" />
            </>
          }
        />
      </>
    )
  }
  return (
    <Form layout="vertical">
      <Form.Item style={{ marginTop: 10 }} label="Client Id">
        <Input
          value={clientId}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setClientId(event.target.value)}
          suffix={getCredentials.loading && <LoadingOutlined />}
        />
      </Form.Item>
      <Form.Item style={{ marginTop: 10 }} label="Client Secret">
        <Input
          value={clientSecret}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setSecret(event.target.value)}
          suffix={getCredentials.loading && <LoadingOutlined />}
        />
      </Form.Item>
      <Form.Item>
        <Button.Group>
          <Button type="primary" onClick={() => submit()} loading={setCredentials.loading}>
            {t('integrationsPage:authorize')}
          </Button>
        </Button.Group>
      </Form.Item>
    </Form>
  )
}

export default SeveraApi
